import { lazy } from 'react';

const RELOAD_KEY = 'sales:chunk-reload';

const isChunkLoadError = (error) =>
    error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed/i.test(String(error?.message || ''));

// A page whose code is downloaded the first time it is opened (React.lazy), instead of with the
// whole app on the first visit.
// After a new deployment an open tab may ask for a file that no longer exists: the page is then
// reloaded once to get the new version, rather than showing a broken screen.
const lazyPage = (load) => lazy(() => load()
    .then((module) => {
        try { sessionStorage.removeItem(RELOAD_KEY); } catch { }
        return module;
    })
    .catch((error) => {
        let alreadyReloaded = false;
        try {
            alreadyReloaded = sessionStorage.getItem(RELOAD_KEY) === '1';
            sessionStorage.setItem(RELOAD_KEY, '1');
        } catch { }
        if (isChunkLoadError(error) && !alreadyReloaded) {
            window.location.reload();
            return new Promise(() => { }); // keep the loader on screen until the reload
        }
        throw error;
    }));

export default lazyPage;
